module.exports = __webpack_public_path__ + "img/DS-Logo-Black1.291e7d0e.png";